<script>

import cTable from "@/base/common/index.vue";
import {apis, uploadCollection} from "@/api/operation_modules/ddu";

export default {
  name: 'dduTracker',
  components: {cTable},
  mounted() {
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {},
      footer: {
      },
      modals: {
        showCollection: {
          methods: {
            ok: ({ row, close }) => {
              if (row.text.trim().length === 0) {
                return this.$Message["warning"]({
                  content: '单号不能为空。格式为 DDU单号/CNB单号, 一行一条录入'
                })
              }

              this.$Spin.show()
              uploadCollection(row).then((res) => {
                this.$Spin.hide()
                if (res.code) {
                  this.$Message["error"]({
                    content: res.msg,
                    duration: 5,
                  })
                } else {
                  this.$Message['success']({
                    content: '数据更新成功',
                    duration: 5,
                    onClose: () => {
                      this.$refs['table'].getList();
                    }
                  })
                }
              }).catch(e => {
                this.$Spin.hide()
                this.$Message["warning"]({
                  content: e.message,
                  duration: 20000,
                })
              })
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {

            }
          },
          grid: [{ text: 24 }],
          fields: [
            {
              name: () => this.$t("partitionName"),
              key: "text",
              component: "Input",
              bind: {
                type: 'textarea',
                rows: 10,
              },
              placeholder() {
                return this.$t("enter") + this.$t("B2B单号和CNB单号，可用/或是=做链接符号");
              }
            },
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "airway_number",
            placeholder() {
              return this.$tz("订单号码");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 },
            },
            methods: {
              "on-enter"() {
                this.handleSubmit();
              },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导入数据"),
              type: "export",
              fnName: "showCollection",
              bind: {
                type: "warning",
              },

            },
          ],
          methods: {
            showCollection() {
              this.getModal('showCollection').open()
            }
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          width: 50,
          align: "center",
        },

        {
          name: () => this.$t("B2B单号"),
          key: "refAwbNo",
          minWidth: 130,
        },
        {
          name: () => this.$t("orderNum"),
          key: "awbno",
          minWidth: 130,
        },

        {
          name: () => this.$t("关联时间"),
          key: "createTime",
          minWidth: 190,
        },
        {
          name: () => this.$t("当前状态"),
          key: "status",
          minWidth: 130,
        },
        {
          name: () => this.$t("状态时间"),
          key: "statusTime",
          minWidth: 200,
        },
        {
          name: () => this.$t("操作人"),
          key: "operator",
          minWidth: 130,
        }
      ],
    };
  },
}
</script>

<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  ></cTable>
</template>

<style scoped>

</style>
